/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import List from '@material-ui/core/List';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import PropTypes from 'prop-types';
import { change, reduxForm } from 'redux-form';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import SingleLineObjective from './SingleLine';
import objectiveServices from '../../../../../redux/services/objectiveServices';

const CoursePlanObject = (props) => {
  const { dataform, initialValues } = props;
  const [data, setData] = useState([]);
  const [loaded, setLoaded] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [allObjectives, setAllObjectives] = useState();

  const initValue = () => {
    if (dataform && dataform.values
      && dataform.values.objectives && dataform.values.objectives.length > 0) {
      setData(dataform.values.objectives);
    } else if (initialValues && initialValues.objectives
      && initialValues.objectives.length > 0) {
      setData(initialValues.objectives);
    }
    setLoaded(true);
  };

  useEffect(() => {
    initValue();
  }, []);

  useEffect(() => {
    objectiveServices.getObjectives()
      .then((res) => {
        setAllObjectives(res);
      });
  }, []);

  const removeRow = (index) => {
    setLoaded(false);
    const newData = [...data];
    newData.splice(index, 1);
    props.dispatch(change(`${props.form}`, 'objectives', newData));
    setData(newData);
    setLoaded(true);
  };

  const updateRow = (newdata, index) => {
    const tmp = [...data];
    tmp[index] = newdata;
    props.dispatch(change(`${props.form}`, 'objectives', tmp));
    setData(tmp);
  };

  const addRow = () => {
    const newData = [...data];
    newData.push({ name: '' });
    props.dispatch(change(`${props.form}`, 'objectives', newData));
    setData(newData);
  };

  if (loaded) {
    let objectives;
    if (data) {
      objectives = data.map((element, key) => (
        <div key={element.name}>
          <SingleLineObjective
            key={element.name}
            name={element.name}
            removeRow={removeRow}
            updateRow={updateRow}
            index={key}
          />
        </div>
      ));
    } else {
      objectives = <div />;
    }

    return (
      <div>
        <List dense={false}>
          {objectives}
        </List>
        <IconButton color="secondary" aria-label="upload picture" component="span" onClick={addRow}>
          <Icon color="secondary" style={{ fontSize: 50 }}>add_circle</Icon>
        </IconButton>
      </div>
    );
  }
  return (<div />);
};

CoursePlanObject.propTypes = {
  dataform: PropTypes.array.isRequired,
  form: PropTypes.any.isRequired,
  dispatch: PropTypes.any.isRequired,
  initialValues: PropTypes.any.isRequired,
};

function mapStateToProps(state) {
  const name = `group_${state.group.selectedGroup._id}`;
  const dataform = state.form[`group_${state.group.selectedGroup._id}`];
  return { initialValues: state.group.selectedGroup, form: name, dataform };
}

const connectedGroupForm = reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
})(injectIntl(CoursePlanObject));

const NewconnectedGroupForm = connect(mapStateToProps, {})(connectedGroupForm);

export default NewconnectedGroupForm;
